import BasePerimeter from '@/perimeters/BasePerimeter';

export default new BasePerimeter({
  purpose: 'navigate',
  can: {
    proceed(action) {
      return this.hasPermission(action);
    }
  }
});
